// extracted by mini-css-extract-plugin
export default {"infoPage":"Info_infoPage__5ecjf","tableContainer":"Info_tableContainer__W3KaB","customTable":"Info_customTable__d0K8f","info-page":"Info_info-page__-52TT"};